<template>
  <div class="mt-1 mb-4">
    <div class="row">
      <div class="col-6 offset-1">
        <datasetDetailsNavigation :with-similar-datasets="withSimilarDatasets" />
      </div>
      <div class="col-4 text-right">
        <datasetDetailsFeedbackButton v-if="withFeedback" />
        <b-dropdown
          class="d-inline"
          size="sm"
          :text="$t('message.datasetDetails.share')"
          variant="light"
        >
          <b-dropdown-item>
            <datasetDetailsShareButton
              :to="`https://www.facebook.com/sharer.php?u=${url}`"
              :icon="{ prefix: 'fab', iconName: 'facebook-f' }"
            />
          </b-dropdown-item>
          <b-dropdown-item>
            <datasetDetailsShareButton
              :to="`https://twitter.com/intent/tweet?url=${url}`"
              :icon="{ prefix: 'fab', iconName: 'twitter' }"
            />
          </b-dropdown-item>
          <b-dropdown-item>
            <datasetDetailsShareButton
              :to="`https://www.linkedin.com/shareArticle?mini=true&url=${url}`"
              :icon="{ prefix: 'fab', iconName: 'linkedin-in' }"
            />
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <div
        v-if="authenticated"
        class="col-12 text-right"
      >
        <datasetDetailsEditButton />
        <datasetDetailsDeleteButton />
      </div>
      <div class="col-12 mt-3">
        <datasetDetailsHeader />
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters, mapActions } from 'vuex';
  import DatasetDetailsNavigation from './EDP2-datasetDetails-navigation';
  import DatasetDetailsFeedbackButton from './EDP2-datasetDetails-feedbackButton';
  import DatasetDetailsShareButton from './EDP2-datasetDetails-shareButton';
  import DatasetDetailsHeader from './EDP2-datasetDetails-header';
  import DatasetDetailsDeleteButton from './EDP2-datasetDetails-deleteButton';
  import DatasetDetailsEditButton from './EDP2-datasetDetails-editButton';
  import { decode } from '@/utils/jwt';

  export default {
    name: 'DatasetDetailsTop',
    dependencies: ['DatasetService'],
    components: {
      datasetDetailsNavigation: DatasetDetailsNavigation,
      datasetDetailsFeedbackButton: DatasetDetailsFeedbackButton,
      datasetDetailsShareButton: DatasetDetailsShareButton,
      datasetDetailsDeleteButton: DatasetDetailsDeleteButton,
      datasetDetailsEditButton: DatasetDetailsEditButton,
      datasetDetailsHeader: DatasetDetailsHeader,
    },
    props: {
      activeTab: {
        type: Number,
        default: 0,
      },
      withSimilarDatasets: {
        type: Boolean,
        default: false,
      },
      withFeedback: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        authenticated: false,
        rtpToken: '',
      };
    },
    computed: {
      // import store-getters
      ...mapGetters('auth', [
        'securityAuth',
        'getRTPToken',
      ]),
      ...mapGetters('datasetDetails', [
        'getCatalog',
      ]),
      catalogId() {
        return this.getCatalog.id;
      },
      url() { return window.location.href; },
    },
    watch: {
       catalogId: {
         immediate: false,
          // In case the user navigates directly to this component,
          // we need to wait until the catalogue ID is loaded
          // and then we can check for authorization
          async handler(newCatalogId) {
            this.authenticated = await this.isAuthenticated(newCatalogId);
          }
      }
    },
    async created() {
      // this.getCatalog.id is assumed to be null when navigated directly
      this.authenticated = await this.isAuthenticated(this.getCatalog.id);
     },
    methods: {
      // import store-actions
      ...mapActions('datasetDetails', [
        'loadDatasetDetails',
        'useService',
      ]),
      decode,
      // Returns true, if the authenticated user has update permissions on this particular dataset
      async isAuthenticated(catalogId) {
        if (!this.$keycloak || !this.$keycloak.authenticated) return false;
        if (!catalogId) return false;

        try {
          const rtpToken = await this.$keycloak.getRtpToken();
          const decodedRtpToken = this.decode(rtpToken.data.access_token);

          const hasUpdatePermissions = decodedRtpToken.authorization.permissions.find((permission) => {
            if (this.getCatalog.id === permission.rsname.replace(`${this.$env.api.catalogBaseUrl}id/catalogue/`, '')) {
              return permission.scopes.find(scope => scope === 'update');
            }
            return false;
          });

          return !!hasUpdatePermissions;
        } catch (ex) {
          return false;
        }

      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/styles/bootstrap_theme';

  /*** MATERIAL ICONS ***/
  .material-icons.small-icon {
    font-size: 20px;
  }
</style>
